<template>
  <applicant-message-reservation-to-applicant
    class="boss-message-box-reserved"
    :message-reservation="messageReservation"
    :entry-id="entryId"
    :reservation-status-label="reservationDateLabel"
    :use-accordion="false"
    @remove="remove"
    @setMessage="setMessage"
  />
</template>

<script>
import _ from 'lodash'
import { createDate } from '@/lib/dateUtils.js'
import ApplicantMessageReservationToApplicant from '@/components/molecules/ApplicantMessageReservationToApplicant'

export default {
  components: {
    ApplicantMessageReservationToApplicant
  },
  props: {
    messageReservation: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: true
    }
  },
  computed: {
    reservationDateLabel () {
      return createDate(this.messageReservation.reservationDate).format('YYYY/MM/DD(ddd)') + ' 10：00頃 送信開始予定'
    }
  },
  methods: {
    remove () {
      this.$http.secured.delete(`/entry/message/send/entries/${this.entryId}/message/reserved_reservation`).then(() => {
        this.$toasted.global.success({ message: 'メッセージを削除しました' })
        this.$emit('fetchAllMessage')
      })
    },
    setMessage () {
      this.$emit('setMessage', _.cloneDeep(this.messageReservation))
    }
  }
}
</script>
